import { IRoleCrudModalLang, ROLE_CRUD_MODAL_LANG_KEY } from './interface.IRoleCrudModalLang'
import { IRolePageLang, ROLE_PAGE_LANG_KEY } from './interface.IRolePageLang'
import { IRoleListTableLang, ROLE_LIST_TABLE_LANG_KEY } from './interface.IRoleListTableLang'
import { IRoleAccessRuleLang, ROLE_ACCESS_RULE_LANG_KEY } from './interface.IRoleAccessRuleLang'

export * from './interface.IRoleCrudModalLang'
export * from './interface.IRolePageLang'
export * from './interface.IRoleListTableLang'
export * from './interface.IRoleAccessRuleLang'

export type IRoleAllLang =
	& IRolePageLang
	& IRoleCrudModalLang
	& IRoleListTableLang
	& IRoleAccessRuleLang

export const ROLE_ALL_LANG_KEY: IRoleAllLang = {
	...ROLE_CRUD_MODAL_LANG_KEY,
	...ROLE_LIST_TABLE_LANG_KEY,
	...ROLE_PAGE_LANG_KEY,
	...ROLE_ACCESS_RULE_LANG_KEY
}